import { dealTypeFromJsonQuery, FDealType, getRangeValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'roomsInDeal' as const;

export const roomsInDealTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const roomsInDeal = getRangeValue('rooms_for_sale')(jsonQuery);

    if (roomsInDeal === null) {
      return null;
    }

    const dealType = dealTypeFromJsonQuery(jsonQuery);
    const { gte, lte } = roomsInDeal;
    const from = gte ? `от ${gte}` : '';
    const to = lte ? `до ${lte}` : '';
    const roomsRange = `${from} ${to}`.trim();

    const label = `Комнат ${dealType === FDealType.Sale ? `на продажу` : `в аренду`}: ${roomsRange}`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['rooms_for_sale'])(jsonQuery),
};
